import React, { useContext, useEffect } from 'react';
import ActionButton from "../../../Buttons/ActionButton";
import StandardModal from "../../../Modals/StandardModal";
import { ReschedulerFormContext, useReschedulerForm } from "./ReschedulerFormProvider";
import ReschedulerForm from "./ReschedulerForm";

const ReschedulerModal = ({
    isExpanded,
    onClose
}) => {
    const {
        localBookingConfig,
        rescheduledAmenityId,
        rescheduledInterval,
        onConfirm,
        onRemove,
        onShow
    } = useReschedulerForm();

    /*
     * Inform the form provider whenever we change modal expanded state
     * Need to do this to stop every recurrence doesn't request a booking config
     * at the same time
     */
    useEffect(() => {
        onShow(isExpanded);
    }, [isExpanded]);

    const handleConfirmRescheduledOccurrence = (event) => {
        onConfirm();
        onClose();
    }

    const handleRemoveOccurrence = (event) => {
        onRemove();
        onClose();
    }

    const isReadyToSelect = () => {
        return (localBookingConfig && rescheduledAmenityId && rescheduledInterval);
    }

    return (
        <StandardModal
            title="Reschedule booking"
            open={ isExpanded}
            onClose={(e) => onClose()}
            style={{
                width: '42rem',
                maxHeight: '86vh',
            }}
            isScrollable
            showGradient
            buttons={[
                <ActionButton
                    title="Select"
                    className="primary"
                    onClick={handleConfirmRescheduledOccurrence}
                    isDisabled={!isReadyToSelect()}
                />
            ]}
            secondaryButtons={[
                <ActionButton
                    title="Remove Occurrence"
                    className="secondary"
                    onClick={handleRemoveOccurrence}
                />
            ]}
        >
            <ReschedulerForm/>
        </StandardModal>
    );
};

ReschedulerModal.propTypes = {};

ReschedulerModal.defaultProps = {};

export default ReschedulerModal;
